var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0407 22.1561L29.7513 27.8654L27.8647 29.7521L22.1553 24.0414C20.031 25.7444 17.3887 26.6706 14.666 26.6667C8.04202 26.6667 2.66602 21.2907 2.66602 14.6667C2.66602 8.04275 8.04202 2.66675 14.666 2.66675C21.29 2.66675 26.666 8.04275 26.666 14.6667C26.6699 17.3894 25.7436 20.0317 24.0407 22.1561ZM21.366 21.1667C23.0582 19.4266 24.0032 17.094 23.9993 14.6667C23.9993 9.50941 19.822 5.33341 14.666 5.33341C9.50868 5.33341 5.33268 9.50941 5.33268 14.6667C5.33268 19.8227 9.50868 24.0001 14.666 24.0001C17.0933 24.0039 19.4259 23.0589 21.166 21.3667L21.366 21.1667Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 14.234L17.6812 11.5527L18.4471 12.3187L15.7658 14.9999L18.4471 17.6812L17.6812 18.4471L14.9999 15.7658L12.3187 18.4471L11.5527 17.6812L14.234 14.9999L11.5527 12.3187L12.3187 11.5527L14.9999 14.234Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.661ab17c.svg";
export { ForwardRef as ReactComponent };